exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".von-checkbox .item-icon-right .icon[_v-dc53eb76]{font-size:36px;right:5px}.von-checkbox input[type=checkbox][_v-dc53eb76]{position:absolute;top:-50000px;left:-50000px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-dc53eb76&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/checkbox/index.vue
// module id = 192
// module chunks = 0